import RevenueChart from './RevenueChart';
import PosTransactionsChart from './PosTransactionsChart';
import AvgCheckChart from './AvgCheckChart';
import { Box, Flex } from '@chakra-ui/react';
import FuelLitersChart from './FuelLitersChart';
import SalesChart from './SalesChart';
import SummaryCard from './SummaryCard';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';

function General() {
  const isStatsSummary = usePermissionStatusByKey('GET:/admin/stats/summary');
  return (
    <>
      <Box display="flex" flexDirection="column" gap={4}>
        <Flex gap={4}>
          {isStatsSummary && <SummaryCard />}

          <SalesChart />
        </Flex>

        <RevenueChart />
        <PosTransactionsChart />
        <AvgCheckChart />
        <FuelLitersChart />
      </Box>
    </>
  );
}

export default General;
